import { useMutation } from '@tanstack/react-query';
import { applyAuthenticatedSession } from 'services/auth/session';
import {
  UserWalletAuthService,
  Verify2faDto,
  Verify2faEntity,
} from 'services/openapi';

export const useVerifyTwoFaMutation = () => {
  const { isLoading, error, data, isError, isSuccess, mutate, mutateAsync } =
    useMutation<Verify2faEntity, Error, Verify2faDto>({
      mutationFn: (variables: Verify2faDto) =>
        UserWalletAuthService.authControllerVerifyTwoFa(variables),
      onSuccess: () => {
        applyAuthenticatedSession();
      },
    });

  return {
    isLoading,
    isSuccess,
    error,
    data,
    isError,
    mutate,
    mutateAsync,
  };
};
